// extracted by mini-css-extract-plugin
export var journeyTimeInformation = "pjmxaPd5FBOkofdKFrPD";